var scope_0 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0f0d4ca40dc45059969d92c1012151ab.js').default;

var scope_1 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1a29bac4f887f862cabc67cc2488d758.js').default;

var scope_2 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/52e38cc9abe267d46b1e1e9a73854e92.js').default;

var scope_3 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/644e0ff1eec8b18a1f3599b5da37868b.js').default;

var scope_4 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/707277bd4763fb120a4c32388a5894fd.js').default;

var scope_5 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/87739f7b6a3f828af6a89a868714ae15.js').default;

var scope_6 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9dac810b8c652e5d1cd2bcd133d37ed4.js').default;

var scope_7 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a52722a585976e2bd829ccb4b90c31f8.js').default;

var scope_8 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cdb8d64da65f349311e6f5bbba731246.js').default;

var scope_9 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e22225b45a6a9788e9f0881340cb23e5.js').default;

var scope_10 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_11 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ea13c15cae51f0b8ab76a5821e83d914.js').default;

var scope_12 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/edf516124216c7ccec20381726320b64.js').default;

var scope_13 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/eeb17cfced85912df283e1a390ef026e.js').default;

var scope_14 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f96e9d6c44322286782ac950c7b51fcf.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14);